// T22.641 (Gordon 2026-10-22): plan-downgrade keep-wheels popup + Archived
// wheel badge. ON for Development only (DevOps-Dev.yml); unset everywhere
// else, so staging and production render byte-identical to before.
export const DOWNGRADE_ARCHIVE_ENABLED =
  process.env.REACT_APP_DOWNGRADE_ARCHIVE === "true";
